import { Data, DateUtils, Model } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../DomainTypes';
import { InvestorInvestmentNoticeRequest } from '../Models/InvestorInvestments/InvestorInvestmentNoticeRequest';
import ActionNoticeRequest from '../Models/InvestorInvestments/Commands/ActionNoticeRequest';

export interface IInvestorInvestmentNoticeApiClient {

    /**
     * Returns active notices, or notices that were cancelled / completed after a given date.
     */
    getNotices(investorInvestmentId: number, fromDate: Date): AxiosPromise<Array<Model.PlainTrackedObject<InvestorInvestmentNoticeRequest>>>;

    /**
     * Actions a notice request.
     */
    actionNoticeRequest(command: Model.PartialPlainObject<ActionNoticeRequest>): AxiosPromise<Model.PlainTrackedObject<Model.UserEvent>>;

    /** 
     * Authorises a notice request.
     */
    authoriseNoticeRequest(noticeRequestId: number): AxiosPromise<Model.PlainObject<Model.UserEvent>>;

    // Client only properties / methods
}

@injectable()
export default class InvestorInvestmentNoticeApiClient extends Data.ApiClientBase implements IInvestorInvestmentNoticeApiClient {

    constructor (config = AppService.get(Types.App.Config)) {
        super(`${config.apiPath}/investor-investment-notices`);
    }

    public getNotices(investorInvestmentId: number, fromDate: Date): AxiosPromise<Array<Model.PlainTrackedObject<InvestorInvestmentNoticeRequest>>> {
        return this.axios.get(`${this.apiPath}/for-investment/${investorInvestmentId}?fromDate=${DateUtils.format(fromDate, "yyyy-MM-dd")}`);
    }

    public actionNoticeRequest(command: Model.PartialPlainObject<ActionNoticeRequest>): AxiosPromise<Model.PlainTrackedObject<Model.UserEvent>> {
        return this.axios.post(`${this.apiPath}/action`, command);
    }

    public authoriseNoticeRequest(noticeRequestId: number): AxiosPromise<Model.PlainObject<Model.UserEvent>> {
        return this.axios.post(`${this.apiPath}/authorise/${noticeRequestId}`);
    }

    // Client only properties / methods
}